import React from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import ChatIcon from './chat.svg';
import styles from './MotivInput.module.scss';

function MotiveInput(props) {
    const { motiv, onChange, slot } = props,
        i18n = useI18n();

    return (
        <div className={styles.MotivInput}>
            <div className={styles.row1}>
                <ChatIcon className={styles.icon} />
                <div className={styles.label}>{slot?.note_description || i18n['meeting-note-description']}</div>
            </div>
            <div className={styles.row2}>
                <textarea className={styles.input} value={motiv} onChange={(e) => onChange(e.target.value)} autoFocus />
            </div>
        </div>
    );
}

export default MotiveInput;
